export default __webpack_public_path__ + "static/media/labeldat2.05974c67.png";